<div class="flex flex-col gap-6 w-full max-w-6xl mx-auto">

    @if (!readOnly()) {
        <header>
            <h2 class="text-xl font-semibold text-p-text m-0">
                {{ 'bookingV2.advanced.title' | translate }}
            </h2>
            <p class="text-sm text-p-text-muted m-0 mt-1">
                {{ 'bookingV2.advanced.subtitle' | translate }}
            </p>
        </header>
    }

    <u2b-tab-switcher
        [tabs]="tabs()"
        [activeId]="activeTab()"
        [ariaLabel]="('bookingV2.advanced.tabsAria' | translate)"
        (tabSelected)="selectTab($event)" />

    <div class="bg-p-content-bg border border-p-border rounded-lg overflow-visible">
        <div class="p-5">
            @switch (activeTab()) {
                @case ('travelers') {
                    <booking-v2-travelers-tab [readOnly]="readOnly()" />
                }
                @case ('power') {
                    <booking-v2-electric-meters-tab [readOnly]="readOnly()" />
                }
                @case ('keys') {
                    <booking-v2-keys-tab [readOnly]="readOnly()" />
                }
                @case ('services') {
                    <booking-v2-services-tab [readOnly]="readOnly()" />
                }
                @case ('documents') {
                    <booking-v2-documents-tab [readOnly]="readOnly()" />
                }
            }
        </div>

        <!-- In-area pager: steps through the advanced sections so the user is not
             thrown straight to the summary by the footer "Weiter" (6585). Hidden
             in the summary's read-only embed. -->
        @if (!readOnly()) {
            @let next = nextTab();
            <div class="flex items-center justify-between gap-3 px-5 py-3 border-t border-p-border bg-p-surface-50">
                @if (previousTab(); as prev) {
                    <p-button severity="secondary" [text]="true" (onClick)="goToPreviousTab()">
                        <span pButtonIcon class="material-icons" style="font-size: 1.125rem">arrow_back</span>
                        <span pButtonLabel>{{ prev.labelKey | translate }}</span>
                    </p-button>
                } @else {
                    <span></span>
                }
                <p-button (onClick)="goToNextTab()">
                    <span pButtonLabel>{{ (next ? next.labelKey : 'bookingV2.advanced.nav.continueToSummary') | translate }}</span>
                    <span pButtonIcon class="material-icons" style="font-size: 1.125rem">arrow_forward</span>
                </p-button>
            </div>
        }
    </div>

</div>
